<template>
  <div class="panel position-relative">

    <div class="header mb-3">
      <div class="float-left">{{ $t('#TR-order') }}</div>
      <div class="float-right small-icon-group">
        <button class="btn btn-danger"
                @click="close">
          <span class="mdi mdi-close"></span>
          <span class="d-none d-md-inline"> {{ $t('#TR-close') }}</span>
        </button>
      </div>
      <div class="clearfix"></div>
    </div>

    <div v-if="order"
         class="panel-body position-relative">
      <div class="row">
        <div class="col-12 px-0">
          <div class="card"
               style="max-width: 700px; margin: 0 auto">
            <h6 class="card-header">
              {{ $t('#TR-order-name') }}: {{ order['orderName'] }}
            </h6>
            <div class="card-body px-2">
              <b-card-text>
                <div class="row">
                  <div class="col-6 font-weight-bold small text-right pr-1 text-truncate">
                    {{ $t('#TR-if-paid') }}:
                  </div>
                  <div class="col-6">
                    <b-badge v-if="order.isPaid"
                             variant="success">
                      {{ $t('#TR-paid') }}
                    </b-badge>
                    <b-badge v-if="!order.isPaid"
                             variant="danger">
                      {{ $t('#TR-not-paid') }}
                    </b-badge>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 font-weight-bold small text-right pr-1 text-nowrap text-truncate ">
                    {{ $t('#TR-table') }}:
                  </div>
                  <div class="col-6">
                    {{ order.tableName }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 font-weight-bold small text-right pr-1 text-nowrap text-truncate">
                    {{ $t('#TR-open-time') }}:
                  </div>
                  <div class="col-6">
                    {{ order.openTime | moment('DD.MM.YYYY, HH:mm') }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 font-weight-bold small text-right pr-1 text-nowrap text-truncate">
                    {{ $t('#TR-station') }}:
                  </div>
                  <div class="col-6">
                    {{ order.station }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 font-weight-bold small text-right pr-1 text-nowrap text-truncate">
                    {{ $t('#TR-creator') }}:
                  </div>
                  <div class="col-6">
                    {{ order.creator }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-6 font-weight-bold small text-right pr-1 text-nowrap text-truncate">
                    {{ $t('#TR-waiter') }}:
                  </div>
                  <div class="col-6">
                    {{ order.waiter }}
                  </div>
                </div>
              </b-card-text>
              <b-card-text>
                <div class="list-group mb-3">

                  <div v-for="(dish, idx) in order.dishes"
                       :key="idx"
                       class="list-group-item">
                    <div class="dish-item">
                      <div class="name">
                        <del class="color-red-800" v-if="dish.voidName">
                          {{ dish.name }}
                        </del>
                        <span v-else>{{ dish.name }}</span>
                        <span v-if="dish.voidName" class="pl-5">
                          <br>{{ dish.voidName }}
                        </span>
                      </div>
                      <div class="qty">{{ dish.qty }}</div>
                      <div class="price">{{ dish.price }}</div>
                    </div>

                    <div class="date small">{{ dish.date | moment('DD.MM.YYYY, HH:mm') }}</div>

                    <div v-if="dish.modifiers.length" class="mb-1"></div>

                    <div v-if="dish.modifiers.length"
                         class="text-muted">
                      <div v-for="(modi, i) in dish.modifiers"
                           :key="i"
                           class="modi-item">
                        <div class="name">{{ modi.name }}</div>
                        <div class="qty">{{ modi.qty }}</div>
                        <div class="price">{{ modi.price }}</div>
                      </div>
                    </div>

                  </div>

                </div>

                <div class="font-weight-bold text-right">
                  {{ $t('#TR-sum') }}: {{ order.orderSum }}
                </div>
              </b-card-text>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  export default {

    props: {
      order: {
        default: () => {
          return null;
        },
        type: Object
      }
    },

    data() {
      return {};
    },

    computed: {
      smallScreen() {
        return this.$store.state.smallScreen;
      }
    },

    methods: {
      close: function () {
        this.$emit('close');
      }
    }

  };
</script>

<style lang="stylus" scoped>

.list-group-item {
  border: 1px solid #ccc;
}


.dish-item {
  display: grid;
  grid-template-columns: auto 60px 60px;
  margin-bottom: 0;

  .name {
  }

  .qty {
    text-align: right;
    font-weight: bold;
  }

  .price {
    text-align: right;
    font-weight: bold;
    padding-right: 10px;
  }
}

.modi-item {
  display: grid;
  grid-template-columns: auto 60px 60px;
  padding: 5px 0 5px 20px;

  &:nth-child(odd) {
    background: #f0f0f0
  }

  .name {}
  .qty {
    text-align: right;
    font-weight: bold;
  }
  .price {
    text-align: right;
    font-weight: bold;
    padding-right: 10px;
  }
}


.darkmode {
  .list-group-item {
    border: 1px solid c-dark-bg;
  }
  .modi-item {
    &:nth-child(odd) {
      background: c-dark-bg
    }
  }
}


</style>
